import { TranslatedValueModel } from './translated-value-model';
import { LanguageModel } from './language.model';

/**
 * Created by vsliwka on 10/05/2017.
 */
export class WorkAddonsModel {
  public id: number;
  public workId: number;
  public addonType: TranslatedValueModel;
  public countryIsoCode: string;
  public addonContent: string;
  public titleCmpl: string;
  public authorCmpl: string;
  public originCmpl: string;
  public dateCmpl: string;
  public synopsisType: TranslatedValueModel;
  public sourceType: TranslatedValueModel;
  public sourceLink: string;
  public sourceNote: string;
  public episodeNumber: number;
  public isOnline: boolean;
  public language: LanguageModel;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
